import React from 'react'
import { CopyOutlined } from '@ant-design/icons'
import { Button, notification } from 'antd'
import { Route } from 'react-router-dom'

import { PromoCodesList } from '~components'
import { getCurrentUser } from '~context'

import './PromoCodesList.modules.css'

const DOMAIN = 'rockettes'
const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}

const getPromoCodeNameWithLink = promocode => <a href={`/promo_codes/${promocode._id}/edit`}>{String(promocode.title).toUpperCase()}</a>
const getPromoCodeDescriptionAsHTML = promocode => <div dangerouslySetInnerHTML={{ __html: promocode.description }}/>
const getPromoCodeCopyLink = id => <Button href={`/promo_codes/${id}/copy`} icon={<CopyOutlined />} type='link'/>

const columnData = [
  {
    render: ({
      _id: id
    }) => getPromoCodeCopyLink(id),
    sorter: false,
    title: '',
    width: '5%'
  },
  {
    dataIndex: 'title',
    render: (text, promocode) => getPromoCodeNameWithLink(promocode),
    sorter: true,
    title: 'Title',
    width: '10%',
    sortDirections: ['descend', 'ascend', 'descend']
  },
  {
    render: promocode => getPromoCodeDescriptionAsHTML(promocode),
    title: 'Description',
    width: '30%'
  },
  {
    render: promocode => promocode.events ? promocode.events.length : '-',
    title: 'Events Count',
    width: '30%'
  }
]

const addNewPromoCode = isContentEditor => {
  return (
    <Route render={({ history }) => (
      <Button
        key="1"
        onClick={() => {
          isContentEditor
            ? history.push(`/promo_codes/${DOMAIN}/new`)
            : notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
        }}
        type="primary"
      >
        Add promo code
      </Button>
    )} />
  )
}

const RockettesPromoCodesList = () => {
  const { userDetails: { isContentEditor } } = getCurrentUser()

  return (
    <PromoCodesList
      columnData={columnData}
      domain={DOMAIN}
      extraActions={[addNewPromoCode(isContentEditor)]}
    />
  )
}

export default RockettesPromoCodesList
